import { ProductDesign, ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import { hasInsertsOfMatchingWidthAndDepth } from 'rangeConfig/bror/filters/mainMenuProductFilter';
import addProduct from 'rangeConfig/bror/behaviors/addProduct';

const sectionsProductListConfig: ProductListConfig = {
  cardsSubtitle: 'communicatedSizeText',
  mobileCardText: 'communicatedSizeText',
  categories: [
    {
      id: 'sections',
      categoryTitle: 'designText',
      cardsSubtitle:
        'communicatedDimensionsLocalized.width communicatedDimensionsLocalized.unit storageone.productCardTextWide',
      products: [
        { path: 'type', value: ProductType.BROR_SECTION },
        { path: 'communicatedDimensions.depth', value: 400 },
        { path: 'communicatedDimensions.depth', value: 550 }
      ]
    },
    {
      id: 'sectionBlack',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.BROR_SECTION },
        { path: 'design', value: ProductDesign.BLACK }
      ]
    },
    {
      id: 'sectionGreyGreen',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.BROR_SECTION },
        { path: 'design', value: ProductDesign.GREY_GREEN }
      ]
    }
  ],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  productFilters: [hasInsertsOfMatchingWidthAndDepth],
  cluster: [],
  sortOrder: [
    { path: 'dimensions.height' },
    { path: 'dimensions.depth' },
    { path: 'dimensions.width' }
  ]
};

export default sectionsProductListConfig;
